import React from 'react';
import { connect } from 'react-redux';
import { fetchUtilisateurs } from 'store/utilisateur/utilisateursActions';
import { closeAffectationDialog } from 'store/common/commonActions';
import { affecter, modifierGroupeAffectation, modifierUtilisateurAffectation, modifierObserverAffectation } from 'store/reclamation/reclamationsActions';
import AffectationDialog from './AffectationDialog';
import { fetchAffectation } from 'store/reclamation/reclamationsActions';

import { fetchReclamation } from 'store/reclamation/detailsActions';
import { initDetailsReclamation } from 'store/reclamation/detailsActions';

import { GroupeTraitementCodes } from 'constants.js';

const Namespace = 'affectationReclamation';

class AffectationDialogContainer extends React.Component {

    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState();

    }
    getInitialState = () => {
        const initialState = {
            disabledSelectUser: false,
            onlyUserId: 0,
            details: {
                valide: true,
                items: []
            }
        };
        return initialState;
    }


    componentDidMount() {
        this.setState(this.getInitialState());
    }


    async componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            let groupeId = await this.props.fetchAffectation(this.props.affectation.reclamationId);

            console.log("componentDidUpdate", groupeId);

            this.props.fetchUtilisateurs(groupeId);

            this.setState({
                disabledSelectUser: false
            });
        }
    }

    handleClickCancel = () => {

        if (!this.props.affectation.autorise) {
            // On invalide la réclamation courante
            this.props.initDetailsReclamation();
            this.props.fetchReclamation(this.props.affectation.reclamation.id);
        }

        this.props.closeAffectationDialog();
    }

    handleClickSelf = () => {
        const { utilisateurCourant, affectation } = this.props;

        let newGroupe;

        // Le groupe n'a pas encore été choisi, on prend le groupe de la réclamation, l'utilisateur en fait forcement partie
        if (affectation.groupe.id === 0) {
            newGroupe = utilisateurCourant.groupes.find(g => g.id === affectation.reclamation.groupe.id);

            this.props.fetchUtilisateurs(newGroupe.id);
            this.props.modifierGroupeAffectation(newGroupe);
        }
        else {
            // Si l'utilisateur n'est pas de ce groupe, on séléctionne le 1er groupe dont il fait partie
            newGroupe = utilisateurCourant.groupes.find(g => g.id === affectation.groupe.id);


            if (newGroupe === undefined) {

                newGroupe = utilisateurCourant.groupes[0];

                this.props.fetchUtilisateurs(newGroupe.id);
                this.props.modifierGroupeAffectation(newGroupe);
            }
        }

        this.props.modifierUtilisateurAffectation(utilisateurCourant);

        this.setState({
            disabledSelectUser: false
        });

        // Si l'utilisateur n'est pas admin/pilote du groupe cible, il ne peut pas affecter d'utilisateur
        if (newGroupe.adminOuPilote === true || affectation.reclamation.utilisateur.id === utilisateurCourant.id) { // on rajoute s'il est lui même affecté à la réclamation
            this.setState({
                onlyUserId: 0
            });
        }
        // Si il est membre du groupe cible, sans en être admin ou pilote, il peut l'affecter, à lui seulement.
        else {
            this.setState({
                onlyUserId: utilisateurCourant.id
            });
        }
    }

    handleChangeGroup = event => {


        const { utilisateurCourant, groupes, affectation } = this.props;


        if (event.target.value === affectation.groupe.id) {
            return; // on ne fait rien si la valeur n'a pas réellement changée.
        }

        let groupeValue = groupes.find(x => x.id === event.target.value);

        this.props.modifierUtilisateurAffectation(
            {
                id: 0,
                codePO: '',
                nom: '',
                prenom: ''
            }
        );
        this.props.modifierGroupeAffectation(groupeValue);
        this.props.fetchUtilisateurs(event.target.value);

        // Si l'utilisateur n'est pas admin/pilote du groupe cible, il ne peut pas affecter d'utilisateur
        let newGroupe = utilisateurCourant.groupes.find(x => x.id === event.target.value);

        let newState = { ...this.state };

        if (!newGroupe) {

            newState = {
                ...newState,
                disabledSelectUser: true,
                onlyUserId: 0
            };
        }
        else {

            newState = {
                ...newState,
                disabledSelectUser: false,
                onlyUserId: 0
            };



            if (newGroupe.adminOuPilote === true || affectation.reclamation.utilisateur.id === utilisateurCourant.id) { // on rajoute s'il est lui même affecté à la réclamation
                newState = {
                    ...newState,
                    onlyUserId: 0
                };
            }
            // Si il est membre du groupe cible, sans en être admin ou pilote, il peut l'affecter, à lui seulement.
            else {
                newState = {
                    ...newState,
                    onlyUserId: utilisateurCourant.id
                };
            }
        }

        if (affectation.reclamation.groupe.code === GroupeTraitementCodes.SERVICE_RAPIDO && affectation.groupe.code === GroupeTraitementCodes.SERVICE_TRANSPORT) {
            newState = {
                ...newState,
                details: {
                    valide: true,
                    items: []
                }
            };
        }
        
        this.setState(newState);
    }

    handleChangeUser = (event) => {

        const { utilisateurs } = this.props;

        let utilisateur = utilisateurs.find(x => x.id === event.target.value);

        this.props.modifierUtilisateurAffectation(utilisateur);
    }

    handleChangeObserver = () => {
        this.props.modifierObserverAffectation(!this.props.affectation.observateur);
    }
    
    handleClickAffecter = () => {
        const { affecter } = this.props;
        const { details } = this.state;

        affecter(details.items);
    }

    handleClickAffecterForcer = () => {
        const { affecter } = this.props;
        const { details } = this.state;

        affecter(details.items, true);
    }


    
    handleChangeDetails = (details) => {
        let newState = {
            ...this.state,
            details: details
        };

        this.setState(newState);
    }


         
    render() {
        const { affectation, utilisateurCourant, open, isAdding } = this.props;
        const { disabledSelectUser, onlyUserId, details } = this.state;
        
        if (!open || affectation === null || affectation.reclamation === null) return null;


        // La validation n'est pas autorisée 
        //      Si le groupe est à 0
        //      s'il n'y a pas eu de changement
        //      si les détails ne sont pas valides
        let validationInterdite = 0;
        if (!details.valide) {
            validationInterdite = 3;
        }

        if (!affectation.autorise) {
            validationInterdite = 4;
        }

        if (affectation.groupe.id === affectation.reclamation.groupe.id) {

            if (affectation.reclamation.utilisateur && affectation.reclamation.utilisateur.id !== 0 && affectation.utilisateur.id === affectation.reclamation.utilisateur.id) {
                validationInterdite = 2;
            }
            else if (affectation.utilisateur.id === 0 && !affectation.adminOuPilote) {
                validationInterdite = 5;
            }
        }

        if (affectation.reclamation.groupe.id === 0) {
            validationInterdite = 1;
        }


        return (
            <AffectationDialog
                open={open}
                affectation={affectation}
                utilisateurCourant={utilisateurCourant}
                onClickCancel={this.handleClickCancel}
                onClickAffecter={this.handleClickAffecter}
                onClickAffecterForcer={this.handleClickAffecterForcer}                
                onClickSelf={this.handleClickSelf}
                onChangeGroup={this.handleChangeGroup}
                onChangeUser={this.handleChangeUser}
                onChangeObserver={this.handleChangeObserver}
                onChangeDetails={this.handleChangeDetails} 
                disabledSelectUser={disabledSelectUser}
                onlyUserId={onlyUserId}
                validationInterdite={validationInterdite}
                namespace={Namespace}
                isAdding={isAdding}
                warningMode={affectation.warningMode}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    open: state.common.affectationDialogOpen,
    isAdding: state.common.affectation.isAdding,
    affectation: state.reclamation.reclamations.affectation,
    utilisateurCourant: JSON.parse(localStorage.getItem('utilisateur')),
    groupes: state.groupe.groupes.items,
    utilisateurs: state.utilisateur.utilisateurs[Namespace].items
});

const mapDispatchToProps = (dispatch) => ({
    closeAffectationDialog: () => dispatch(closeAffectationDialog()),
    affecter: (details, forcer = false, declenchee = false) => dispatch(affecter(details, forcer, declenchee)),
    fetchUtilisateurs: (groupeId) => dispatch(fetchUtilisateurs(Namespace, groupeId)),
    fetchAffectation: (reclamationId) => dispatch(fetchAffectation(reclamationId)),
    modifierGroupeAffectation: (groupe) => dispatch(modifierGroupeAffectation(groupe)),
    modifierUtilisateurAffectation: (utilisateur) => dispatch(modifierUtilisateurAffectation(utilisateur)),
    modifierObserverAffectation: (observateur) => dispatch(modifierObserverAffectation(observateur)),
    fetchReclamation: id => dispatch(fetchReclamation(id)),
    initDetailsReclamation: () => dispatch(initDetailsReclamation())
});

export default connect(mapStateToProps, mapDispatchToProps)(AffectationDialogContainer);